import styled from 'styled-components';
import { ButtonTag } from '../Button/styles';

export const FormFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 25px;
  margin-bottom: 30px;
`;

export const ForgotButton = styled.button`
  margin: 0;
  padding: 0;
  
  color: inherit;
  font-size: 14px;
  
  border: none;
  background-color: transparent;
  
  cursor: pointer;
  transition: color 0.3s;
  
  &:hover {
    color: ${({ theme }) => theme.blue};
  }
`;

export const LoginButton = styled(ButtonTag)`
  margin-right: 25px;
  padding: 13px 40px;
`;

export const SignUpButton = styled.button`
  margin: 0;
  padding: 0;
  
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.blue};
  
  background-color: transparent;
  border: none;
  outline: none;
  
  cursor: pointer;
  
  transition: color 0.3s;
  
  &:hover {
    color: ${({ theme }) => theme.black};
  }
`;

export const ErrorMessage = styled.p`
  margin: 0;
  margin-top: 10px;
  padding: 0;
  
  font-size: 14px;
  color: ${({ theme }) => theme.red};
`;

export const LoginSocial = styled.ul`
  display: flex;
  flex-shrink: 0;
  margin-bottom: 15px;
  
  border: 1px solid #ebebeb;
  border-radius: 6px;
  
  li {
    width: 50%;
     
    &:first-child {
      border-right: 1px solid #ebebeb;
    }
  }
`;

export const LoginSocialButton = styled.a`
  display: flex;
  align-items: center;
  padding: 10px;
  
  font-size: 14px;
  line-height: 1;
  color: #8d8d8d;
  text-align: left;
  
  cursor: pointer;
  
  transition: color 0.3s;
  
  &:hover {
    color: ${({ theme }) => theme.black};
  }
  
  svg {
    flex-shrink: 0;
    margin-right: 5px;
  }
  
  @media(min-width: 768px) {
    padding: 20px 25px;
  }
`;
